import { useEffect, useState } from 'react';
import api from '~/services/api';
import { toast } from 'react-toastify';

export const useStores = (role, userId) => {
  const [stores, setStores] = useState([]);
  const [loadingStores, setLoadingStores] = useState(false);

  useEffect(() => {
    let isMounted = true; // Flag de controle para evitar memory leak

    const loadStores = async () => {
      try {
        setLoadingStores(true);
        const { data } = await api.get(
          `/${role}/users/${userId}/managed_stores`
        );
        if (isMounted) {
          // Verifica se ainda está montado
          const storesList = data.managed_stores.map(store => ({
            label: store.fantasy_name,
            value: store.id,
          }));
          setStores(storesList);
        }
      } catch (err) {
        if (isMounted) {
          console.error(err);
          toast.error('Erro ao carregar as lojas.');
        }
      } finally {
        if (isMounted) {
          setLoadingStores(false);
        }
      }
    };

    loadStores();

    return () => {
      isMounted = false; // Cleanup: previne setState se desmontar
    };
  }, [role, userId]);

  return { stores, loadingStores };
};
